import Log from '@deephaven/log';
import { useFiber } from "./useFiber.js";
import { usePanelId } from "./usePanelId.js";
var log = Log.module('useDhId');
export var DH_ID_PROP = '__dhId';

/**
 * Gets the Deephaven ID of a component.
 * This is used to identify the component within a dashboard.
 * Usually this is just a panel ID, but in some contexts such as dh.ui,
 * it may be an ID for a component within a panel.
 *
 * Looks for a __dhId prop on the component, and if not found, looks in the PanelIdContext.
 * @param props The props of the component using this hook
 * @returns The Deephaven ID of the component or null if not found.
 */
export function useDhId() {
  var _ref, _useFiber;
  // pendingProps are the props passed to the fiber node
  var props = (_ref = (_useFiber = useFiber()) === null || _useFiber === void 0 ? void 0 : _useFiber.pendingProps) !== null && _ref !== void 0 ? _ref : {};
  var dhIdProp = props[DH_ID_PROP];
  var panelId = usePanelId();
  if (dhIdProp != null) {
    if (typeof dhIdProp !== 'string') {
      throw new Error("useDhId expected prop ".concat(DH_ID_PROP, " to be a string, but got ").concat(typeof dhIdProp));
    }
    return dhIdProp;
  }
  if (panelId == null) {
    log.warn("useDhId must be used within a PanelIdContext provider if there is no ".concat(DH_ID_PROP, " prop. Defaulting to null."));
    return null;
  }
  return panelId;
}
//# sourceMappingURL=useDhId.js.map